import {
  DetailedAlertMessages,
  Paragraph,
} from '@sentara-health/optimahealth_web';
import { useTranslation } from 'react-i18next';
import LongButtonModal from './LongButtonModal';

interface CoBrowseConsentModalProps {
  isOpen: boolean;
  agentName: string;
  onApprove: () => void;
  onDecline: () => void;
}

const CoBrowseConsentModal = ({
  isOpen,
  agentName,
  onApprove,
  onDecline,
}: CoBrowseConsentModalProps) => {
  const { t } = useTranslation();

  return (
    <LongButtonModal
      isOpen={isOpen}
      onClose={onDecline}
      header={t('openReplay.consentModal.header', { agentName })}
      body={
        <>
          <Paragraph
            variant="regular"
            text={t('openReplay.consentModal.body')}
          />
          <div className="mt-3">
            <DetailedAlertMessages
              message={t('openReplay.consentModal.privacyNotice')}
              dismissible={false}
              variant="success"
              type="lock"
            />
          </div>
        </>
      }
      buttonLabel={t('openReplay.consentModal.acceptButton')}
      buttonTestId="cobrowse-accept-btn"
      onConfirm={onApprove}
      secondaryButtonLabel={t('openReplay.consentModal.denyButton')}
      secondaryButtonTestId="cobrowse-decline-btn"
      onSecondaryClick={onDecline}
      footerNote={
        <Paragraph
          className="mb-0"
          text={
            <em style={{ fontSize: '0.85rem', color: '#6B7280' }}>
              {t('openReplay.consentModal.footerNote')}
            </em>
          }
        />
      }
    />
  );
};

export default CoBrowseConsentModal;
